export default {"src":"/_next/static/media/play-icon.146b9caf.svg","height":512,"width":513};